
import { components } from '~/slices'

export default {
  name: 'SportsPage',
  async asyncData({ app, $prismic, params, error }) {
    const sportPage = await $prismic.api.getByUID('sport_page', params.slug, {
      lang: app.i18n.localeProperties.prismic,
    })

    if (sportPage) {
      return { sportPage }
    } else {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },
  nuxtI18n: {
    paths: {
      de: '/sport/:slug',
      en: '/sports/:slug', // -> accessible at /about-us (no prefix since it's the default locale)
    },
  },
  data() {
    return { components }
  },
  head() {
    if (this.sportPage && this.sportPage.data) {
      return {
        title: this.sportPage.data.meta_titel + ' | ATHLYZER',
        meta: [
          {
            hid: 'og-title',
            property: 'og:title',
            content: this.sportPage.data.meta_titel + ' | ATHLYZER',
          },
          {
            hid: 'description',
            name: 'description',
            content: this.sportPage.data.meta_beschreibung,
          },
          {
            hid: 'og-desc',
            property: 'og:description',
            content: this.sportPage.data.meta_beschreibung,
          },
          {
            hid: 'og-image',
            property: 'og:image',
            content: this.sportPage.data.open_graph_image
              ? this.sportPage.data.open_graph_image.url
              : '/ATHLYZER_OG.jpg',
          },
        ],
      }
    }
  },
}
